<template>
  <div class="addinsurer">
    <TableToolTemp :toolListProps="{ toolTitle: '减少被保险人' }"> </TableToolTemp>
    <el-tabs type="border-card" v-model="activeName" ref="target" v-if="showEdited">
      <el-tab-pane label="减少被保人" name="edited">
        <div class="addtable">
          <el-form
            :model="addJsonForm"
            ref="addJsonForm"
            :rules="addJsonForm.addJsonRules"
            :inline="true"
            label-width="108px"
          >
            <el-table :data="addJsonForm.params" border @selection-change="handleSelectionChange" :max-height="500">
              <el-table-column type="selection"> </el-table-column>
              <el-table-column align="center" width="150">
                <template slot="header">
                  <span>被保人姓名</span>
                  <i style="color: #f56c6c">*</i>
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.insuredName'"
                    :rules="addJsonForm.addJsonRules.insuredName"
                  >
                    <el-input placeholder="被保险人姓名" v-model="scope.row.insuredName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column align="center" width="200">
                <template slot="header">
                  <span>证件类型</span>
                  <i style="color: #f56c6c">*</i>
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.insuredCardType'"
                    :rules="addJsonForm.addJsonRules.insuredCardType"
                  >
                    <el-select clearable placeholder="证件类型" v-model="scope.row.insuredCardType">
                      <el-option
                        v-for="(ite, ind) in dicMap['gen.identityType']"
                        :key="ind"
                        :label="ite.dicItemName"
                        :value="ite.dicItemCode"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column align="center" width="220">
                <template slot="header">
                  <span>证件号码</span>
                  <i style="color: #f56c6c">*</i>
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.insuredCardNo'"
                    :rules="addJsonForm.addJsonRules.insuredCardNo"
                  >
                    <el-input placeholder="证件号码" v-model="scope.row.insuredCardNo"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" width="220">
                <template slot="header">
                  <span>失效止期</span>
                  <i style="color: #f56c6c">*</i>
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'params.' + scope.$index + '.invalidTime'"
                    :rules="addJsonForm.addJsonRules.invalidTime"
                  >
                    <el-date-picker
                      style="width: 150px"
                      v-model="scope.row.invalidTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: (date) => {
                          return date && date.valueOf() >+new Date()|| (date.valueOf()<+new Date() - 60*24*3600*1000);
                        },
                      }"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" width="220">
                <template slot="header">
                  <span>异常原因</span>
                </template>
                <template slot-scope="scope">
                  <span>{{ scope.row.unusualReason }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="deleterow(scope)">删除</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.unusualReason == '重复'"
                    @click="recover(scope.row)"
                    >确认覆盖</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div>
          <el-button type="text" icon="iconfont icondt8" @click="addrow">增加新一行</el-button>
        </div>
        <div>
          <el-button type="text" icon="iconfont icondt24" v-if="selectArr.length >= 2" @click="deleterowBymultiple"
            >批量删除</el-button
          >
        </div>
        <div class="save-btn">
          <el-button plain type="primary" @click="saveInsurer">保存</el-button>
          <el-button type="primary" @click="submitToGcbs">提交</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="批量减少" name="upload">
        <el-form label-position="left">
          <el-form-item>
            <el-row>
              <el-upload
                class="upload-demo"
                ref="upload"
                action
                :on-remove="handleRemove"
                :on-success="handlesuccess"
                :before-upload="handleBeforeupload"
                :http-request="handleUploadForm"
                :file-list="importdata"
                :auto-upload="false"
                :limit="2"
                :on-change="uploadChange"
                accept='.xlsx,.xls'
              >
                <el-button slot="trigger" type="primary">选择导入模板</el-button>
              </el-upload>
              <el-button type="primary" @click="submitUpload">批量导入</el-button>
            </el-row>
          </el-form-item>
          <div>
            <el-button type="text" @click="downLoadTemplate">下载导入模版</el-button>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <!-- 提交到团财成功后，显示的列表 -->
    <div class="gcbs-wrapper" v-if="!showEdited">
      <Table :data="tableData" :options="listDataOptions" align="center"> </Table>
      <Pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pageData="initParam"
        :total="total"
      ></Pagination>
      <div class="save-btn">
        <el-button plain type="primary" @click="commitToxf">确认提交</el-button>
        <el-button type="primary" @click="gobackEdit">返回</el-button>
      </div>
    </div>
    <!-- 连带被保人弹窗 -->

    <DtPopup
      :isShow.sync="addPopupShow"
      @close="closerelative"
      title="连带被保险人提示"
      :footer="false"
      :width="'800px'"
    >
      <Table :data="relative" :options="relativeDataOptions" align="center"></Table>
      <div class="surebtn">
        <el-button type="primary" @click="handlesubmitRelative">确认并继续</el-button>
      </div>
    </DtPopup>

    <!-- 提交到 幸福 成功和异常的弹窗-->
    <DtPopup
      :isShow.sync="xfPopupShow"
      @close="gohistory(xfPopupShowtitle, xfporpInfo)"
      :title="xfPopupShowtitle"
      :footer="false"
    >
      <div class="popup-text">
        <span v-if="xfPopupShowtitle == '提交成功'">保全号：{{ xfporpInfo }}</span>
        <span v-if="xfPopupShowtitle == '提交失败'">失败原因：{{ xfporpInfo }}</span>
      </div>
      <div style="text-align: center; margin-top: 20px; margin-bottom: 20px">
        <el-button type="primary" @click="gohistory(xfPopupShowtitle, xfporpInfo)">返回</el-button>
      </div>
    </DtPopup>
  </div>
</template>
<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import Table from '@/components/layouts/table';
import DtPopup from '@/components/layouts/DtPopup';
import Pagination from '@/components/layouts/Pagination';
import dayjs from 'dayjs';
import {
  preservationdownload,
  preservationupload,
  preservationgetDetail,
  preservationgetPlan,
  preservationsaveInsured,
  preservationsubmitToGcbs,
  preservationinsuredList,
  preservationconfirmCover,
  preservationdelete,
  preservationsubmitToXfrs,
  preservationsubmitRelative,
  preservationbatchDelete,
  preservationedit,
  preservationcloseRelative,
} from '@/api/securityManage';
import { myMixin } from '@/mixins';
import { validateIdCard } from '@/utils/utils';
export default {
  mixins: [myMixin],
  components: {
    TableToolTemp,
    Table,
    DtPopup,
    Pagination,
  },
  computed: {
    dicMap() {
      return this.$store.state.dicMap;
    },
  },
  watch: {
    activeName(val) {
      if (val == 'upload') {
        this.saveInsurer();
      }
    },
  },
  data() {
    return {
      xfPopupShow: false,
      xfPopupShowtitle: '提交成功',
      xfporpInfo: {},
      dicArr: [
        'gen.gender', //  性别
        'gen.identityType', // 证件类型
        'gcbs.occupation.type', // 职业类别
        'bbc.preservation.rela', //与职员关系关系
        'gcbs.rela.with.staff', //与职员关系关系
        'gcbs.preservation.status', //保全状态
        'gcbs.social.insurance', //有无社保
      ],
      activeName: 'edited',
      addJsonForm: {
        params: [
          {
            insuredName: '',
            insuredCardType: '',
            insuredCardNo: '',
            isLocal: true,
            index: 1,
            invalidTime:dayjs().format("YYYY-MM-DD"),
          },
        ],
        addJsonRules: {
          insuredName: [{ required: true, message: '请填写被保人姓名', trigger: 'blur' }],
          insuredCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
          insuredCardNo: [
            { required: true, message: '请填写证件号码', trigger: 'blur' },
            { validator: this.analysisIdCard, trigger: ['blur', 'change'] },
          ],
          invalidTime: [{ required: true, message: '请选择日期', trigger: 'change' }],
        },
      },
      index: 1,
      importdata: [],
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          preservationId: this.$route.query.preservationId,
          preservationType: this.$route.query.preservationType,
        },
      },
      gcbsParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          preservationId: this.$route.query.preservationId,
          preservationType: this.$route.query.preservationType,
          policyId: this.$route.query.policyId,
        },
      },
      total: 0,
      planArr: [],
      showEdited: true, // 标示当前是添加还是已经提交到团财
      tableData: [],
      listDataOptions: [
        {
          prop: 'insuredName',
          label: '被保人姓名',
        },
        {
          prop: 'insuredCardType',
          label: '证件类型',
          dic: 'gen.identityType',
        },
        {
          prop: 'insuredCardNo',
          label: '证件号码',
        },
        {
          prop: 'gender',
          label: '性别',
          dic: 'gen.gender',
        },
        {
          prop: 'birthday',
          label: '出生日期',
        },
        {
          prop: 'relaWithStaff',
          label: '与员工关系',
          dic: 'gcbs.rela.with.staff',
        },
        {
          prop: 'planName',
          label: '保险计划',
        },
        {
          prop: 'occupationType',
          label: '职业类别',
          dic: 'gcbs.occupation.type',
        },
        {
          prop: 'socialSecurity',
          label: '医保标识',
          dic: 'gcbs.social.insurance',
        },
        {
          prop: 'insuredPhoneNo',
          label: '移动电话',
        },
        {
          prop: 'subInsuredCardType',
          label: '主被保险人证件类型',
          dic: 'gen.identityType',
        },
        {
          prop: 'subInsuredCardNo',
          label: '主被保险人证件号码',
        },
        {
          prop: 'invalidTime',
          label: '失效止期',
        },
      ],
      addPopupShow: false,
      relative: [],
      relativeDataOptions: [
        {
          prop: 'insuredName',
          label: '被保人姓名',
        },
        {
          prop: 'subInsuredName',
          label: '主被保人姓名',
        },
        {
          prop: 'relaWithStaff',
          label: '与员工关系',
          dic: 'gcbs.rela.with.staff',
        },
        {
          prop: 'insuredCardType',
          label: '证件类型',
          dic: 'gen.identityType',
        },
        {
          prop: 'insuredCardNo',
          label: '证件号码',
        },
        {
          prop: 'gender',
          label: '性别',
          dic: 'gen.gender',
        },
        {
          prop: 'birthday',
          label: '出生日期',
        },
      ],
      selectArr: [], //批量删除的数组
      file: null,
      closeFlag: true, //标识是否是点击关闭按钮
    };
  },
  methods: {
    uploadChange(file, fileList) {
      this.file = file.raw;
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove() {
      this.importdata = [];
      this.file = null;
    },
    handlesuccess(response) {
      if (response.resp_code == 0) {
        this.$message('导入成功');
      } else {
        this.$message.error(response.resp_msg);
      }

      this.importdata = [];
    },
    handleBeforeupload() {},
    handleUploadForm(params) {
      if (!params.file) {
        this.$message.error('请先选择文件');
        return;
      }
      let formDate = new FormData();
      formDate.append('policyId', this.$route.query.policyId);
      formDate.append('preservationId', this.$route.query.preservationId);
      formDate.append('type', this.$route.query.type);
      formDate.append('file', params.file);
      formDate.append('comId', this.$route.query.comId,);
      this.$confirm('本操作将覆盖现有数据，是否继续?', '提示', {
        confirmButtonText: '确定覆盖',
        cancelButtonText: '取消覆盖',
        type: 'warning',
      })
        .then(() => {
          formDate.append('cover', '1');
          preservationupload(formDate).then((res) => {
            if (res && res.resp_code == 0) {
              this.getAll();
              this.activeName = 'edited';
            }
          });
        })
        .catch(() => {
          formDate.append('cover', '0');
          preservationupload(formDate).then((res) => {
            if (res && res.resp_code == 0) {
              this.getAll();
              this.activeName = 'edited';
            }
          });
        });
    },
    submitUpload() {
      if (!this.file) {
        this.$message.error('请先选择模板');
        return;
      }
      this.$refs.upload.submit();
    },
    downLoadTemplate() {
      preservationdownload('批量减人导入模板.xlsx', {
        type: this.$route.query.type,
        comId:this.$route.query.comId,
      });
    },
    getdetail() {
      //带分页
      preservationgetDetail(this.gcbsParam).then((response) => {
        if (response && Array.isArray(response.list)) {
          this.tableData = response.list.map((element) => {
            // 保险计划转换
            let planNamearr = this.planArr.filter((item) => {
              return item.planId == element.planId;
            });
            planNamearr[0] && (element.planName = planNamearr[0].planName);
            return element;
          });
          this.total = response.total;
        }
      });
    },

    getAll() {
      // 不带分页 ,返回所有数据
      let { preservationId, preservationType } = this.$route.query;
      preservationinsuredList({ preservationId, preservationType }).then((res) => {
        if (res && Array.isArray(res)&&res.length) {

          let configres=[]
          res.map(item=>{
            configres.push({
              insuredName: item.insuredName,
            insuredCardType: item.insuredCardType,
            insuredCardNo: item.insuredCardNo,
            unusualReason:item.unusualReason,
            invalidTime: item.invalidTime|| dayjs().format("YYYY-MM-DD"),
            unusualReason:item.unusualReason,
            middlewareInsuredId:item.insuredId,
            oldmiddlewareInsuredId:item.oldInsuredId
            })
          })
          this.addJsonForm.params = configres;
          this.$refs.addJsonForm.clearValidate();
        }
      });
    },
    async getplan() {
      let res = await preservationgetPlan({ policyId: this.$route.query.policyId });
      if (res) {
        //返回的是map，转为array
        for (let key in res) {
          this.planArr.push({
            planName: key,
            planId: res[key],
          });
        }
      }
    },
    addrow() {
      let index = this.index + 1;
      this.index = index;
      this.addJsonForm.params.push({
        insuredName: '',
        insuredCardType: '',
        insuredCardNo: '',
        isLocal: true,
        index,
        invalidTime:dayjs().format("YYYY-MM-DD"),
      });
    },
    deleterow(data) {
      let rowData = this.addJsonForm.params;
      if (data.row.isLocal) {
        //手动增加得数据
        this.addJsonForm.params = rowData.filter((item, index) => {
          return index != data.$index;
        });
      } else {
        //导入的数据删除
        let { preservationId } = this.$route.query;
        preservationdelete({
          insuredId: data.row.middlewareInsuredId,
          preservationId,
          insuredCardNo: data.row.insuredCardNo,
          oldInsuredId:data.row.oldmiddlewareInsuredId,
        }).then((res) => {
          if (res && res.resp_code == 0) {
            this.addJsonForm.params = this.addJsonForm.params.filter((item, index) => {
              return item.middlewareInsuredId != data.row.middlewareInsuredId;
            });
          }
        });
      }
      // 如果删除后列表为空 为其添加一条空数据
      if (this.addJsonForm.params.length <= 0) {
        this.addrow();
      }
    },
    // 批量删除，区分导入和手动添加
    deleterowBymultiple() {
      let selectArr = this.selectArr;
      //区分手动添加和导入数据 带index 得为手动添加  带insuredId为导入数据
      let handlearr = selectArr.filter((item) => {
        return item.index;
      });
      let importarr = selectArr.filter((item) => {
        return item.middlewareInsuredId;
      });
      //手动添加得直接删除
      if (handlearr && handlearr.length) {
        for (let i = 0; i < handlearr.length; i++) {
          this.addJsonForm.params = this.addJsonForm.params.filter((item) => {
            return item.index != handlearr[i].index;
          });
        }
      }
      //导入的数据 调用批量删除接口
      if (importarr && importarr.length) {
        preservationbatchDelete(importarr).then((res) => {
          for (let i = 0; i < importarr.length; i++) {
            this.addJsonForm.params = this.addJsonForm.params.filter((item) => {
              return item.middlewareInsuredId != importarr[i].middlewareInsuredId;
            });
          }
        });
      }
      // 如果删除后列表为空 为其添加一条空数据
      if (this.addJsonForm.params.length <= 0) {
        this.addrow();
      }
    },
    saveInsurer() {
      // 保存不校验
      for (let key in this.addJsonForm.addJsonRules) {
        this.addJsonForm.addJsonRules[key][0].required = false;
      }
      //保存被保人
      let { policyId, preservationId, type, comId} = this.$route.query;
      let status = type;
      let list = this.addJsonForm.params.filter((item) => {
        // 过滤掉全是空数据的item

        return item.insuredName != '' || item.insuredCardType != '' || item.insuredCardNo != '';
      });
      list &&
        list.length &&
        preservationsaveInsured({
          policyId,
          preservationId,
          status,
          list,
          comId
        }).then((res) => {
          if (res) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            });
            this.getAll();
            this.$refs.addJsonForm.clearValidate();
          }
        });
      //   }
      // });
    },
    submitToGcbs() {
      //提交到团财
      for (let key in this.addJsonForm.addJsonRules) {
        this.addJsonForm.addJsonRules[key][0].required = true;
      }
      let { preservationId, type, policyId ,policyCode,comId} = this.$route.query;
      this.$refs.addJsonForm.validate((valid) => {
        if (valid) {
          preservationsubmitToGcbs({
            policyId,
            preservationId,
            type,
            list: this.addJsonForm.params,
            policyCode,
            comId
          }).then((res) => {
            if (res && res.resp_code == 0) {
              this.showEdited = false;
              this.getdetail();
            } else if (res && Array.isArray(res.relative)) {
              //有关联被保人
              this.addPopupShow = true;
              this.relative = res.relative.map((item) => {
                item.birthday = item.birthday.split('00:00:00')[0];
                return item;
              });
            } else {
              this.getAll();
            }
          });
        }
      });
    },
    handlesubmitRelative() {
      this.closeFlag = false;
      preservationsubmitRelative({
        list: this.relative,
      }).then((res) => {
        if (res && res.resp_code == 0) {
          this.addPopupShow = false;
          this.showEdited = false;
          preservationgetDetail(this.gcbsParam).then((response) => {
            if (response && Array.isArray(response.list)) {
              this.tableData = response.list.map((element) => {
                // 保险计划转换
                let planNamearr = this.planArr.filter((item) => {
                  return item.planId == element.planId;
                });
                planNamearr[0] && (element.planName = planNamearr[0].planName);
                return element;
              });
              this.total = response.total;
              this.flacloseFlagg = true;
            }
          });
        }
      });
    },
    // 提交到幸福人寿
    commitToxf() {
      let { policyId, preservationId, type } = this.$route.query;
      preservationsubmitToXfrs({
        policyId,
        type,
        preservationId,
      }).then((res) => {
        if (res.code == 1) {
          //失败
          this.xfPopupShow = true;
          this.xfPopupShowtitle = '提交失败';
          this.xfporpInfo = res.msg;
        } else if (res.code == 0) {
          //成功
          this.xfPopupShow = true;
          this.xfPopupShowtitle = '提交成功';
          this.xfporpInfo = res.msg;
        }
      });
    },
    closerelative() {
      let { preservationId } = this.$route.query;
      //
      this.closeFlag &&
        preservationcloseRelative({ preservationId }).then((res) => {
          if (res && Array.isArray(res)) {
            this.addJsonForm.params = res;
            this.addPopupShow = false;
          }
        });
    },
    gohistory() {
      let { policyId, policyCode } = this.$route.query;
      this.$router.replace({
        name: 'historyhold',
        query: {
          policyId,
          policyCode,
          comId:this.$route.query.comId,
        },
      });
    },
    handleSelectionChange(val) {
      this.selectArr = val;
    },
    insuredCardTypeselectchange(index, val) {
      if (val != '01') {
        // 不是身份证类型
        this.addJsonForm.params[index].disable = false;
      }
    },
    recover(data) {
      preservationconfirmCover({
        insuredId: data.middlewareInsuredId,
        oldInsuredId: data.oldmiddlewareInsuredId,
      }).then((res) => {
        if (res && res.resp_code == 0) {
          this.getAll(false);
        }
      });
    },
    handleSizeChange(val) {
      this.gcbsParam.pageNum = 1;
      this.gcbsParam.pageSize = val;
      this.getdetail();
    },
    handleCurrentChange(val) {
      this.gcbsParam.pageNum = val;
      this.getdetail(false);
    },

    //验证部分
    analysisIdCard(rule, value, callback) {
      let index = rule.field.split('params.')[1].split('.insuredCardNo')[0];
      let type = this.addJsonForm.params[index].insuredCardType;
      if (type == '01') {
        //是身份证类型
        if (!value) return;
        if (value.length != 18) {
          callback(new Error('身份证号码位数不正确'));
        } else {
          if (validateIdCard(value)) {
            callback();
          } else {
            callback(new Error('身份证号码无法识别，请输入正确号码'));
          }
        }
      } else {
        callback();
      }
    },
    gobackEdit() {
      preservationedit({ preservationId: this.$route.query.preservationId }).then((res) => {
        if (res) {
          this.showEdited = true;
          this.getAll();
        }
      });
    },
  },
  created() {
    // this.getdetail();
    let { from } = this.$route.query;
    from && this.getAll();
    this.getplan();
  },
};
</script>
<style lang="less" scoped>
.addinsurer {
  .actions {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #aaaaaf;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .addtable {
    width: 100%;
    overflow-x: auto;
    margin-top: 18px;
    .form-head {
      white-space: nowrap;
      height: 42px;
      line-height: 42px;
      background: #fafafa;
      border: 1px solid #dcdce1;
      span {
        display: inline-block;
        width: 130px;
        text-align: center;
        font-size: 14px;
        i {
          color: rgba(255, 67, 76, 1);
        }
      }
    }
    .demo-form-inline {
      white-space: nowrap;
    }
  }
}
.upload-demo {
  display: inline-block;
  margin-right: 20px;
}
.save-btn {
  margin-top: 30px;
}
.surebtn {
  margin: 30px auto;
  text-align: center;
}
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 20px 33px;
}
/deep/.el-upload-list.el-upload-list--text {
  display: inline-block;
  vertical-align: bottom;
  border: 1px solid #dcdce1;
  margin-left: 12px;
}
/deep/.el-upload-list__item:first-child {
  margin: 0;
}
/deep/.el-tabs__nav-scroll {
  background: white;
  border-bottom: 2px solid rgba(226, 124, 0, 1);
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #e27c00;
  color: white;
  &:hover {
    color: white;
  }
}
/deep/.el-button--primary.is-plain:hover {
  color: #e27c00;
}
/deep/.el-button--primary.is-plain:active {
  color: #e27c00;
}
/deep/.el-button--primary.is-plain:focus {
  color: #e27c00;
}
</style>